import { render, staticRenderFns } from "./SubListItem.vue?vue&type=template&id=6771a970&scoped=true"
import script from "./SubListItem.vue?vue&type=script&lang=js"
export * from "./SubListItem.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6771a970",
  null
  
)

export default component.exports